import { getDayOfWeek, timeOfWeek } from './time_helpers'
import { isMobile, getParameterByName } from './browser_helpers'

export const analyticNamingMLB = (title, status) => {
    let section

    if (status === 'Pre-Game') {
        section = 'pre-game preview'
    } else if (status === 'In-Progress') {
        section = 'in-progress live'
    } else {
        section = 'post game summary'
    }

    if (title === 'Play-by-Play' && status === 'In-Progress') {
        section = 'in-progress play by play'
    } else if (title === 'Play-by-Play' && status === 'Final') {
        section = 'post game play by play'
    } else if (title === 'Live-Game') {
        section = 'in-progress live'
    } else if (title === 'Boxscore' && status === 'In-Progress') {
        section = 'in-progress boxscore'
    } else if (title === 'Boxscore' && status === 'Final') {
        section = 'post game boxscore'
    }

    return {
        section,
    }
}

export const analyticNamingNHL = (title, status, additions) => {
    let section

    if (status === 'Pre-Game') {
        section = 'pre-game preview'
    } else if (status === 'In-Progress') {
        section = 'in-progress live'
    } else {
        section = 'post game summary'
    }

    if (title === 'Video' && status === 'In-Progress') {
        section = 'in-progress video'
    } else if (title === 'Video' && status === 'Final') {
        section = 'post game video'
    } else if (title === 'Live') {
        section = 'in-progress live'
    } else if (title === 'Boxscore' && status === 'In-Progress') {
        section = 'in-progress boxscore'
    } else if (title === 'Boxscore' && status === 'Final') {
        section = 'post game boxscore'
    }

    return {
        section: additions ? section + ' ' + additions.toLowerCase() : section,
    }
}

export const analyticNamingHockey = (status, additions) => {
    let section

    if (status === 'Pre-Game') {
        section = 'pre-game preview'
    } else if (status === 'In-Progress') {
        section = 'in-progress live'
    } else {
        section = 'post game summary'
    }

    return {
        section: additions ? section + ' ' + additions.toLowerCase() : section,
    }
}

export const analyticNamingNBA = (status, additions) => {
    let section

    if (status === 'Pre-Game') {
        section = 'pre-game preview'
    } else if (status === 'In-Progress') {
        section = 'in-progress live'
    } else {
        section = 'post game summary'
    }

    return {
        section: additions ? section + ' ' + additions.toLowerCase() : section,
    }
}
export const analyticNamingSoccer = (status, additions) => {
    let section

    if (status === 'Pre-Game') {
        section = 'pre-game preview'
    } else if (status === 'In-Progress') {
        section = 'in-progress live'
    } else {
        section = 'post game summary'
    }

    return {
        section: additions ? section + ' ' + additions.toLowerCase() : section,
    }
}
export const analyticNamingFootball = (status, additions) => {
    let section

    if (status === 'Pre-Game') {
        section = 'pre-game preview'
    } else if (status === 'In-Progress') {
        section = 'in-progress live'
    } else {
        section = 'post game summary'
    }

    return {
        section: additions ? section + ' ' + additions.toLowerCase() : section,
    }
}

export const fireAnalytics = (
    actionName,
    widget_name,
    position,
    destinationUrl,
    text_clicked_content,
    type
) => {
    const action = {
        type: type,
        redirect: true,
        actionName: actionName,
        link: {
            destinationURL: destinationUrl,
            position_no: position,
            sourceURL: window.location.href || document.URL,
            text_clicked_content: text_clicked_content,
            widget_name: widget_name,
        },
    }
    dispatchAnalytics(action)
}

export const dispatchAnalytics = action => {
    switch (action.type) {
        case 'ANALYTIC_EVENT_PAGE':
            window.rdm.dtm.dl = {
                account: 'rogersrmisports',
                brand: 'Sportsnet',
                tags: '',
                cmsid: '3993957',
                pages: `sportsnet : ${action.naming.sport} : ${action.naming.league} : ${action.naming.page}`,
                pageURL: action.naming.url,
                section: `sportsnet : ${action.naming.sport}`,
                subSection: `sportsnet : ${action.naming.sport} : ${action.naming.league}`,
                subSection2: `sportsnet : ${action.naming.sport} : ${action.naming.league} : ${action.naming.page}`,
                category: action.naming.category,
                linkPage: action.naming.season || '',
                contentName: '',
                contentType: '',
                authorName: '',
                vmxC4: 'SPORTSNET',
                video: {},
                vmxEnabled: false,
                complete90percent: false,
            }
            if (window._satellite) {
                window._satellite.setVar(
                    'react_page_name',
                    `${action.naming.league || ''} ${action.naming.page || ''}`
                )
                window._satellite.track('react_page')
            }
            break

        case 'DTM_LIVETRACKER_EVENT':
            window.rdm.dtm.dl = window.rdm.dtm.dl || {}
            window.rdm.dtm.dl.game = {
                leagueName: action.naming.leagueName,
                sportName: action.naming.sportName,
                gameName: action.naming.gameName,
                teamName: action.naming.teamName,
                gameState: action.naming.gameState,
            }

            if (window._satellite) {
                window._satellite.track('livetracker')
            }

            break

        case 'ANALYTIC_EVENT_LIVETRACKER_ACTION':
            window.rdm.dtm.dl = {
                actionName: action.json.actionName || '',
                playerName: action.json.playerName || '',
                gameClock: action.json.gameClock || '',
            }
            if (window._satellite) {
                window._satellite.track('LTaction')
            }
            break

        case 'ANALYTIC_EVENT_LIVETRACKER_NHL_VIDEO': {
            let videoObj = {
                widgetName: `${action.naming.section}`,
                position: `Pos ${action.video_position}`,
                videoTitle: action.video_title,
                pageUrl: window.location.href || document.URL || '',
            }
            window.rdm.dtm.dl.LTlinktracking = Object.keys(videoObj)
                .map(function(i) {
                    return videoObj[i]
                })
                .join(';')
            if (window._satellite) {
                window._satellite.track('videoclick')
            }
            break
        }

        case 'ANALYTIC_EVENT_LIVETRACKER_VIDEO_SLIDER': {
            let videoObj = {
                widgetName: `${action.naming.section}`,
                position: `Pos ${action.video_position}`,
                videoTitle: action.video_title,
                pageUrl: window.location.href || document.URL || '',
            }
            window.rdm.dtm.dl.LTlinktracking = Object.keys(videoObj)
                .map(function(i) {
                    return videoObj[i]
                })
                .join(';')
            if (window._satellite) {
                window._satellite.track('videoclick')
            }
            break
        }

        case 'ANALYTIC_EVENT_NHL_INTERMISSION_MODAL':
            if (window._satellite) {
                if (action.open) {
                    window._satellite.track('game summary view')
                }
                if (!action.open) {
                    window._satellite.setVar('close type', action.close_action)
                    window._satellite.track('game summary hide')
                }
            }
            break

        case 'ANALYTIC_EVENT_TEAM_PROFILE':
            if (window._satellite) {
                if (action.teamPage) {
                    window._satellite.setVar(
                        'react_page_name',
                        `${action.teamPage.league + ' ' + action.teamPage.pageName}`
                    )
                    window._satellite.setVar('team_name', action.teamPage.teamName)
                    window._satellite.track('react_page')
                } else if (action.redirect) {
                    window._satellite.setVar('mod_event', action.actionName)
                    if (action.link) {
                        window.rdm.dtm.dl = {
                            linkPage: action.link,
                        }
                    }
                    window._satellite.track('module_event')
                }
            }
            break

        case 'ANALYTIC_EVENT_BROADCAST_SCHEDULE':
            if (window._satellite) {
                if (action.redirect) {
                    window._satellite.setVar('mod_event', action.actionName)
                    if (action.link) {
                        window.rdm.dtm.dl = {
                            linkPage: action.link,
                        }
                    }
                    window._satellite.track('module_event')
                }
            }
            break
        case 'DTM_TRACK_ADD_TO_SCHEDULE':
            if (window._satellite) {
                window._satellite.track('addToSchedule', { origin: action.origin })
            }
            break
        case 'ANALYTIC_EVENT_SCORES_PAGE_ACTION':
            window.rdm.dtm.dl = {
                ...action.json,
            }
            if (window._satellite) {
                window._satellite.track(action.name)
            }
            break
    }
}

export const getCookie = cname => {
    let name = cname + '='
    let decodedCookie = decodeURIComponent(document.cookie)
    let ca = decodedCookie.split(';')
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i]
        while (c.charAt(0) === ' ') {
            c = c.substring(1)
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length)
        }
    }
    return ''
}
